

export interface EventSource<E extends string = string>
{
    off(event: E, handler: EventHandler): this;
    on(event: E, handler: EventHandler): this;
}


export interface EventEmitter<E extends string = string> extends EventSource<E>
{
    emit<T>(event: E, args?: T): this;
}


export namespace EventEmitter
{
    export function create<E extends string = string>(): EventEmitter<E>
    {
        return new DefaultEventEmitter<E>();
    }
}


export class DefaultEventEmitter<E extends string = string> implements EventEmitter<E>
{
    constructor()
    {
    }

    off(event: E, handler: EventHandler): this
    {
        const eventHandlers = this.events[event];
        if (eventHandlers)
            this.events[event] = eventHandlers.filter(item => item != handler);
        return this;
    }

    on(event: E, handler: EventHandler): this
    {
        const eventHandlers = this.events[event] ?? (this.events[event] = []);
        eventHandlers.push(handler);
        return this;
    }

    emit(event: E, arg?: any): this
    {
        const eventHandlers = this.events[event];
        eventHandlers?.forEach(handler => handler(arg));
        return this;
    }


    private events: Partial<Record<E, EventHandler[]>> = {};
}


export type EventHandler<T = any> = (arg: T) => void;


export type EventHandlerFor<T extends EventSource, E extends EventOf<T>> =
    Parameters<T["on"]>[0] extends E ? Parameters<T["on"]>[1] : EventHandler;


export type EventOf<T> = T extends EventSource<infer E> ? E : never;


export type EventArgsFor<T extends EventSource, E extends EventOf<T>> =
    Parameters<EventHandlerFor<T, E>>[0];


// export type EventArgsFor<T extends EventSource, E extends EventOf<T>> =
//     Parameters<T["on"]>[0] extends E ?
//     Parameters<T["on"]>[1] extends EventHandler<infer A> ?
//     A : never : never;
